import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import SizePills from "./size-pills";
import { fetchAvailability as fetchBuyAvailability, fetchPricing as fetchBuyPricing } from "slices/pdp-buy-slice";
import { setSelectedSizeSku } from "slices/pdp-slice";
import AddToBag from "./add-to-bag";
import { ASSORTMENTS } from "rtr-constants";
import AddressZipUpdater from "./address-zip-updater";
import BuynowPrice from "./pricing/buynow-pricing";
import AddToBagError from "./add-to-bag-error";

export default function BuynowBuyBox() {
  const dispatch = useDispatch();
  const staticProduct = useSelector(state => state.staticProduct);
  const categoryRoot = useSelector(state => state.staticProduct?.categoryRoot);
  const depotId = useSelector(state => state.workingFilters?.depotId);
  const availability = useSelector(state => state.pdp?.buy?.availability?.items);
  const availabilityLoaded = useSelector(state => state.pdp?.buy?.availabilityLoaded);
  const availabilityError = useSelector(state => state.pdp?.buy?.availabilityError);
  const [selectedSize, setSelectedSize] = useState(null);

  useEffect(() => {
    if (!staticProduct?.productId) return;

    if (depotId) {
      dispatch(fetchBuyAvailability({ productId: staticProduct.productId, depotIds: depotId }));
    }
  }, [dispatch, staticProduct?.productId, depotId]);

  useEffect(() => {
    dispatch(fetchBuyPricing({ productId: staticProduct.productId }));
  }, []);

  const handleSizeSelect = size => {
    setSelectedSize(size);
    if (size?.sku) {
      dispatch(setSelectedSizeSku(size.sku));
    }
  };

  return (
    <section className="mt-6" data-test-id="buynow-buy-box" aria-labelledby="buy-add-to-bag">
      <BuynowPrice />
      <SizePills
        skus={staticProduct?.skus}
        availability={availability}
        availabilityLoaded={availabilityLoaded}
        availabilityError={availabilityError}
        onSelect={handleSizeSelect}
        hideOneSize={categoryRoot === ASSORTMENTS.WOMENS_ACCESSORIES}
      />
      <AddToBagError />
      <AddToBag
        isBuy={true}
        membershipError={null}
        availability={availability}
        availabilityLoaded={availabilityLoaded}
        selectedSize={selectedSize}
      />
      <AddressZipUpdater mode={"buy"} isGridProductDrawer={false} />
    </section>
  );
}
